import React from "react";
import { Card, CardBody, Col, FormGroup, Input, Label, Table } from "reactstrap";
import { Link } from "react-router-dom";
import CommonCardHeader from "../../../Utils/CommonComponents/CommonCardHeader/CommonCardHeader";
import { monthlyDropdownList, orderHistoryTable } from "../../../Data/Dashboard/Default";
import { dynamicImage } from "../../../Utils";
import { Btn, H5, Image, P } from "../../../AbstractElements";

const Order = () => {
  return (
    <Col xl="7" className="xl-100 xl-order-1 box-col-12">
      <Card>
        <CommonCardHeader headClass="pb-0 card-no-border" mainTitle dropDownList={monthlyDropdownList} title={"Order History "} />
        <CardBody className="pt-0 recent">
          <div className="table-responsive theme-scrollbar">
            <div className="dataTables_wrapper no-footer">
              <div className="dataTables_filter">
                <label>
                  Search:
                  <input type="search" />
                </label>
              </div>
              <Table className="display dataTable no-footer">
                <thead>
                  <tr>
                    <th className="sorting_asc">
                      <FormGroup check>
                        <Input type="checkbox" />
                        <Label check />
                      </FormGroup>
                    </th>
                    <th className="sorting">No.</th>
                    <th className="sorting">Customer Name</th>
                    <th className="sorting">ID</th>
                    <th className="sorting">Date</th>
                    <th className="sorting">City</th>
                    <th className="sorting">Status</th>
                    <th className="sorting">Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {orderHistoryTable.map((data, index) => (
                    <tr role="row" className="even" key={index}>
                      <td className="sorting_1">
                        <FormGroup check>
                          <Input type="checkbox" />
                          <Label check />
                        </FormGroup>
                      </td>
                      <td>{index + 1}</td>
                      <td>
                        <div className="d-flex">
                          <div className="flex-shrink-0">
                            <Image src={dynamicImage(`dashboard/order/${index + 1}.png`)} alt="image"/>
                          </div>
                          <div className="flex-grow-1 ms-3">
                            <Link to={`${process.env.PUBLIC_URL}/users/user_profile`}>
                              <H5>{data.name}</H5>
                            </Link>
                            <P>{data.role}</P>
                          </div>
                        </div>
                      </td>
                      <td>{data.orderNumber}</td>
                      <td>{data.date}</td>
                      <td>{data.location}</td>
                      <td>
                        <Btn color={data.color} className="text-white">
                          {'Cancel'}
                        </Btn>
                      </td>
                      <td>{data.amount}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default Order;
